import React, { useState } from "react";
import { toast } from "react-toastify";
import apiClient from "../api/axios";

export default function ChangePasswordForm({ endpoint = "/customer/change-password" }) {
  const [passwords, setPasswords] = useState({
    current_password: "",
    new_password: "",
    new_password_confirmation: "",
  });
  const [loading, setLoading] = useState(false);

  const handlePasswordChange = (e) => {
    setPasswords({ ...passwords, [e.target.name]: e.target.value });
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await apiClient.put(endpoint, passwords, { withCredentials: true });
      const data = res.data;
      if (data.status === "success") {
        toast.success(data.message || "Password updated successfully");
        setPasswords({
          current_password: "",
          new_password: "",
          new_password_confirmation: "",
        });
      } else if (data.errors) {
        Object.values(data.errors).flat().forEach(msg => toast.error(msg));
      } else {
        toast.error(data.message || "Failed to update password");
      }
    } catch (e) {
      const errors = e?.response?.data?.errors;
      if (errors) {
        Object.values(errors).flat().forEach(msg => toast.error(msg));
      } else {
        toast.error(e?.response?.data?.message || "Failed to update password");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="title-header option-title">
        <h5>Change Password</h5>
      </div>
      <form className="theme-form theme-form-2 mega-form" onSubmit={handlePasswordSubmit}>
        <div className="row">
          <div className="mb-4 row align-items-center">
            <label className="form-label-title col-lg-2 col-md-3 mb-0">Current Password</label>
            <div className="col-md-9 col-lg-10">
              <input className="form-control" type="password" name="current_password" value={passwords.current_password} onChange={handlePasswordChange} placeholder="Current Password" required />
            </div>
          </div>
          <div className="mb-4 row align-items-center">
            <label className="form-label-title col-lg-2 col-md-3 mb-0">New Password</label>
            <div className="col-md-9 col-lg-10">
              <input className="form-control" type="password" name="new_password" value={passwords.new_password} onChange={handlePasswordChange} placeholder="New Password" required />
            </div>
          </div>
          <div className="mb-4 row align-items-center">
            <label className="form-label-title col-lg-2 col-md-3 mb-0">Confirm New Password</label>
            <div className="col-md-9 col-lg-10">
              <input className="form-control" type="password" name="new_password_confirmation" value={passwords.new_password_confirmation} onChange={handlePasswordChange} placeholder="Confirm New Password" required />
            </div>
          </div>
        </div>
        <div className="card-submit-button">
          <button className="btn btn-animation ms-auto" type="submit" disabled={loading}>
            {loading ? "Changing..." : "Change Password"}
          </button>
        </div>
      </form>
    </>
  );
} 